import * as types from '@/store/types'
import constConf from '../../../constconf'
import Vue from 'vue'
import actionRequests from './actionRequests'

export default {
    cardAll: (context, botId) => {
        let url = constConf.shop.url + '/card/all/' + botId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('cardAll', response.response.data)
                } else {
                    context.commit('cardAll', [])
                }
            })
    },
    cardAllByCardListReturnOnly: (context, cardListId) => {
        let url = constConf.shop.url + '/card/all-by-card-list/' + cardListId
        return context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => { return response })
    },
    cardsInCardAll: (context, cardId) => {
        let url = constConf.shop.url + '/card/cards-in-card-all/' + cardId
        return context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                return response
            })
    },
    cardAllByCategory: (context, categoryId) => {
        let url = constConf.shop.url + '/card/all-by-category/' + categoryId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('cardAll', response.response.data)
                } else {
                    context.commit('cardAll', [])
                }
            })
    },
    cardCreate: (context, data) => {
        let method = 'post'
        let url = constConf.shop.url + '/card/create'
        if (data.id != null) {
            method = 'put'
            url = constConf.shop.url + '/card/update'
        }
        let payload = { method: method, url: url, data: data }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                if (response.ok) {
                    let functionName = { put: 'cardUpdate', post: 'cardCreate' }
                    context.commit(functionName[method], response.response.data)
                    return response
                } else {
                    return response
                }
            })
    },
    cardDelete: (context, cardId) => {
        let payload = { method: 'delete', url: constConf.shop.url + '/card/delete/' + cardId }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                if (response.ok) {
                    context.commit('cardDelete', response.response.data)
                }
                return response
            })
    },
    createTempCard: (context, payload) => {
        return context.commit('createTempCard', payload)
    },
    changeBotIdModelDefault: (context, botId) => {
        context.commit('changeBotIdModelDefault', botId)
    },
    cardListAll: (context, botId) => {
        let url = constConf.shop.url + '/card-list/all/' + botId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('cardListAll', response.response.data)
                } else {
                    context.commit('cardListAll', [])
                }
            })
    },
    cardListAllByCategory: (context, cardCategoryId) => {
        let url = constConf.shop.url + '/card-list/all-by-category/' + cardCategoryId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('cardListAll', response.response.data)
                    context.commit('lastLoadedCategoryIdUpdate', +cardCategoryId)
                } else {
                    context.commit('cardListAll', [])
                }
            })
    },
    cardListAllByCategoryReturnOnly: (context, cardCategoryId) => {
        let url = constConf.shop.url + '/card-list/all-by-category/' + cardCategoryId
        return context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => { return response })
    },
    cardListCreate: (context, data) => {
        let method = 'post'
        let url = constConf.shop.url + '/card-list/create'
        if (data.id != null) {
            method = 'put'
            url = constConf.shop.url + '/card-list/update'
        }
        let payload = { method: method, url: url, data: data }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                if (response.ok) {
                    let functionName = { put: 'cardListUpdate', post: 'cardListCreate' }
                    context.commit(functionName[method], response.response.data)
                    return response
                } else {
                    return null
                }
            })
    },
    cardListDelete: (context, id) => {
        let url = constConf.shop.url + '/card-list/delete/' + id
        return context.dispatch('axios/query', { url: url, method: 'delete' }, { root: true })
            .then(response => {
                if (response.ok) {
                    context.commit('cardListDelete', response.response.data)
                }
                return response
            })
    },
    loadCardSortedInList: (context, payload) => { // загрузка и распределение сообщений по спискам
        let unsortedCards = context.getters.cards.slice()
        let cardSortedInList = {}
        payload.cardLists.forEach((item) => {
            if (!cardSortedInList.hasOwnProperty(item.id)) {
                Vue.set(cardSortedInList, item.id, [])
            }
            if (item.cards.length !== 0) {
                item.cards.forEach((cardId) => {
                    let card = context.getters.getCardById(+cardId)
                    if (card) { cardSortedInList[item.id].push(card) }
                    let index = unsortedCards.findIndex(card => card.id === +cardId)
                    unsortedCards.splice(index, 1)
                })
            }
        })
        unsortedCards.forEach((card) => {
            cardSortedInList[context.getters.unsortedCardsListId].push(card)
        })
        context.commit('loadCardSortedInList', cardSortedInList)
        context.commit('allLoadedChangeValue', false)
    },
    allLoadedChangeValue: (context) => {
        context.commit('allLoadedChangeValue', false)
    },
    sortCardsInCardList: (context, payload) => {
        let cards = []
        let unique = []
        for (let i = (context.getters.cardSortedInList[payload.cardListId].length - 1); i >= 0; i--) {
            if (unique.indexOf(context.getters.cardSortedInList[payload.cardListId][i].id) >= 0) { // если в списке уже есть сообщение с похожим id, значит нужно удалить его
                context.commit('deleteCardInCardList', { cardListId: payload.cardListId, index: i })
            } else {
                unique.push(context.getters.cardSortedInList[payload.cardListId][i].id)
                cards.push(context.getters.cardSortedInList[payload.cardListId][i].id)
            }
        }
        cards.reverse()
        return cards
    },
    addCardToCardList: (context, payload) => {
        context.commit('addCardToCardList', payload)
    },
    updateCardInCardList: (context, payload) => {
        context.commit('updateCardInCardList', payload)
    },
    cardCommentAll: (context, cardId) => {
        let url = constConf.shop.url + '/card-comment/all/' + cardId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('cardCommentAll', response.response.data)
                } else {
                    context.commit('cardCommentAll', [])
                }
            })
    },
    cardCommentCreate: (context, data) => {
        let method = 'post'
        let url = constConf.shop.url + '/card-comment/create'
        if (data.id != null) {
            method = 'put'
            url = constConf.shop.url + '/card-comment/update'
        }
        let payload = { method: method, url: url, data: data }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                if (response.ok) {
                    let functionName = { put: 'cardCommentUpdate', post: 'cardCommentCreate' }
                    context.commit(functionName[method], response.response.data)
                    return response.response.data
                } else {
                    return data
                }
            })
    },
    cardCommentDelete: (context, cardId) => {
        let payload = { method: 'delete', url: constConf.shop.url + '/card-comment/delete/' + cardId }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                if (response.ok) {
                    context.commit('cardCommentDelete', response.response.data)
                }
                return response
            })
    },
    cardChangeList: (context, data) => {
        let card = Object.assign({}, context.getters.getCardById(data.cardId))
        if (card) {
            card.card_list_id = data.cardListId
            let payload = { method: 'post', url: constConf.shop.url + '/card/update', data: card }
            return context.dispatch('axios/queryWithData', payload, { root: true })
                .then(response => {
                    if (response.ok) {
                        context.commit('cardUpdate', response.response.data)
                    }
                    return response
                })
        }
    },
    cardCategoryAll: (context, botId) => {
        let url = constConf.shop.url + '/card-category/all/' + botId
        context.dispatch('axios/query', { url: url }, { root: true })
            .then(response => {
                if (response.ok === true) {
                    context.commit('cardCategoryAll', response.response.data)
                } else {
                    context.commit('cardCategoryAll', [])
                }
            })
    },
    cardCategoryCreate: (context, data) => {
        let method = 'post'
        let url = constConf.shop.url + '/card-category/create'
        if (data.id != null) {
            method = 'put'
            url = constConf.shop.url + '/card-category/update'
        }
        let payload = { method: method, url: url, data: data }
        return context.dispatch('axios/queryWithData', payload, { root: true })
            .then(response => {
                if (response.ok) {
                    let functionName = { put: 'cardCategoryUpdate', post: 'cardCategoryCreate' }
                    context.commit(functionName[method], response.response.data)
                    return response
                } else {
                    return null
                }
            })
    },
    cardCategoryDelete: (context, id) => {
        let url = constConf.shop.url + '/card-category/delete/' + id
        return context.dispatch('axios/query', { url: url, method: 'delete' }, { root: true })
            .then(response => {
                if (response.ok) {
                    context.commit('cardCategoryDelete', response.response.data)
                }
                return response
            })
    },
    cardCategoryShowChange: (context, value) => {
        context.commit('cardCategoryShowChange', value)
        return value
    },
    addCard: (context, value) => {
        context.commit('addCard', value)
    },
    ...actionRequests
}
